import { CRUISE_SEO_DATA, SET_SEO_DATA, SET_SEO_FILTERS } from '../constants/seoConstants';

export const seoInitialState = {};

const seoReducer = (state = seoInitialState, action) => {
  switch (action.type) {
    case SET_SEO_DATA:
      return {
        ...state,
        metaData: action.payload,
      };
    case SET_SEO_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case CRUISE_SEO_DATA: {
      return {
        ...state,
        cruiseListing: action.payload.cruiseData,
        cruiseBranch: action.payload.cruiseBranch,
      };
    }
    default:
      return state;
  }
};

export default seoReducer;
